import { AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import BaseMfaVerifyCustomizer from './base';

export default class MfaVerifyQuestionCustomizer extends BaseMfaVerifyCustomizer {
  async shouldCustomize() {
    return [ 'mfa-verify-question' ].includes(this.context?.controller);
  }
  forgifyController() {
    AmplitudeUtils.logMfaChallengeEvent(`Landing::${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}FactorSelect`);
    super.forgifyController();
  }
}
